export enum CarouselVariant {
  CAROUSEL_VARIANT_UNKNOWN = 'CAROUSEL_VARIANT_UNKNOWN',
  /**
   * title
   * tile, tile, tile, ...  Web + App
   */
  CAROUSEL_VARIANT_DEFAULT = 'CAROUSEL_VARIANT_DEFAULT',
  /**
   * title | tile, tile, tile, ...  Web only
   * @deprecated
   */
  CAROUSEL_VARIANT_TITLE_LEFT = 'CAROUSEL_VARIANT_TITLE_LEFT',
  /**
   * Web only.
   * Tiles are filled top to bottom, left to right, like so:
   * tile1, tile3, tile5, ...
   * tile2, tile4, .....
   */
  CAROUSEL_VARIANT_TWO_ROW = 'CAROUSEL_VARIANT_TWO_ROW',
  /**
   * Displays two rows when tile count >= 2n-1 where n is determined
   * by the responsiveTilesPerSlide value for the current viewport.
   * Tiles are filled top to bottom, left to right.
   * E.g. with 5 tiles and n=6:
   * tile1, tile3, tile5, ...
   * tile2, tile4, .....
   * With 4 or less tiles, the carousel has one row:
   * tile1, tile2, tile3...
   */
  CAROUSEL_VARIANT_DYNAMIC_TWO_ROW = 'CAROUSEL_VARIANT_DYNAMIC_TWO_ROW',
}
